function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var postcss = require('postcss');
var IMPORTANT = /\s*!important\s*$/i;
var UNITLESS = {
  'box-flex': true,
  'box-flex-group': true,
  'column-count': true,
  'flex': true,
  'flex-grow': true,
  'flex-positive': true,
  'flex-shrink': true,
  'flex-negative': true,
  'font-weight': true,
  'line-clamp': true,
  'line-height': true,
  'opacity': true,
  'order': true,
  'orphans': true,
  'tab-size': true,
  'widows': true,
  'z-index': true,
  'zoom': true,
  'fill-opacity': true,
  'stroke-dashoffset': true,
  'stroke-opacity': true,
  'stroke-width': true
};
function dashify(str) {
  return str.replace(/([A-Z])/g, '-$1').replace(/^ms-/, '-ms-').toLowerCase();
}
function decl(parent, name, value) {
  if (value === false || value === null) return;
  name = dashify(name);
  if (typeof value === 'number') {
    if (value === 0 || UNITLESS[name]) {
      value = value.toString();
    } else {
      value += 'px';
    }
  }
  if (name === 'css-float') name = 'float';
  if (IMPORTANT.test(value)) {
    value = value.replace(IMPORTANT, '');
    parent.push(postcss.decl({
      prop: name,
      value: value,
      important: true
    }));
  } else {
    parent.push(postcss.decl({
      prop: name,
      value: value
    }));
  }
}
function atRule(parent, parts, value) {
  var node = postcss.atRule({
    name: parts[1],
    params: parts[3] || ''
  });
  if (typeof value === 'object') {
    node.nodes = [];
    parse(value, node);
  }
  parent.push(node);
}
function parse(obj, parent) {
  var name, value, node;
  for (name in obj) {
    value = obj[name];
    if (value === null || typeof value === 'undefined') {
      continue;
    } else if (name[0] === '@') {
      var parts = name.match(/@(\S+)(\s+([\W\w]*)\s*)?/);
      if (Array.isArray(value)) {
        var _iterator = _createForOfIteratorHelper(value),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var i = _step.value;
            atRule(parent, parts, i);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        atRule(parent, parts, value);
      }
    } else if (Array.isArray(value)) {
      var _iterator2 = _createForOfIteratorHelper(value),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _i = _step2.value;
          decl(parent, name, _i);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    } else if (typeof value === 'object') {
      node = postcss.rule({
        selector: name
      });
      parse(value, node);
      parent.push(node);
    } else {
      decl(parent, name, value);
    }
  }
}
module.exports = function (obj) {
  var root = postcss.root();
  parse(obj, root);
  return root;
};